import apiServiceCall from "../services/ApiServiceCall";
import ApiServiceUploadCall from "../services/ApiServiceUploadCall";
                              
export const getForm = (serviceID,loggedUserCedula) => {
    return apiServiceCall().get(`/expertform/${serviceID}/get/${loggedUserCedula}`).then(({data}) => data);
}

export const registerForm = (requestData) => {
    return apiServiceCall().post('/requests',requestData).then(({data}) => data);
}

export const uploadFormDocuments = (documentsList,uploadConfig) => {
    return ApiServiceUploadCall().post('/files',documentsList,uploadConfig).then(({data}) => data);
}

// Queues every attached file to be sent to SoftExpert asynchronously (backend
// dispatches one job per file and returns immediately instead of the caller
// waiting for each SOAP call to finish). activity_id is always needed so the
// fileprovider can associate the document to the right workflow activity.
// Pass advance_activity: true only when the workflow activity itself should
// advance once every file in the batch has finished (e.g. resubmitting
// documents for a required action) — a brand new request must NOT advance it.
export const linkingDocumentsToRequestInSoftExpert = (code, documents, { activity_id, advance_activity = false } = {}) => {
    return apiServiceCall().post(`/requests/${code}/documents`, { documents, activity_id, advance_activity }).then(({data}) => data);
}

// Polls the status of the files queued above for a given request code.
export const getSoftExpertDocumentsStatus = (code) => {
    return apiServiceCall().get(`/requests/${code}/documents/status`).then(({data}) => data);
}

export const linkingDocumentsToRequestInBackOffice = (filesList,requestID) => {
    return apiServiceCall().post(`/assigndocument/${requestID}`,filesList).then(({data}) => data);
}

export const cancelRequest = (requestID) => {
    return apiServiceCall().post(`/cancelrequests/${requestID}`).then(({ data }) => data);
}